import { z } from 'zod'

import { adminListSearchSchema } from '@/core/lib/table-search-schema'
import { QUESTION_POOL_STATUSES } from '@/modules/question-pool/question-pool.constants'

export const questionPoolSearchSchema = adminListSearchSchema

export const questionPoolStatusSchema = z.enum(QUESTION_POOL_STATUSES)

const questionPoolNameSchema = z
  .string()
  .trim()
  .min(2, { message: 'En az 2 karakter olmalı.' })
  .max(120, { message: 'En fazla 120 karakter olabilir.' })

const questionPoolDescriptionSchema = z
  .string()
  .trim()
  .max(1000, { message: 'En fazla 1000 karakter olabilir.' })
  .optional()
  .nullable()

export const createQuestionPoolSchema = z.object({
  name: questionPoolNameSchema,
  description: questionPoolDescriptionSchema,
  status: questionPoolStatusSchema,
})

export const editQuestionPoolSchema = z.object({
  name: questionPoolNameSchema.optional(),
  description: questionPoolDescriptionSchema,
  status: questionPoolStatusSchema.optional(),
})

export const updateQuestionPoolQuestionsSchema = z
  .object({
    add_question_ids: z.array(z.string().min(1)).default([]),
    remove_question_ids: z.array(z.string().min(1)).default([]),
    allow_move: z.boolean().default(false),
  })
  .superRefine((value, context) => {
    const addIds = new Set(value.add_question_ids)
    const removeIds = new Set(value.remove_question_ids)

    if (addIds.size !== value.add_question_ids.length) {
      context.addIssue({
        code: 'custom',
        message: 'Eklenecek soru listesinde tekrar eden kayıt var.',
        path: ['add_question_ids'],
      })
    }

    if (removeIds.size !== value.remove_question_ids.length) {
      context.addIssue({
        code: 'custom',
        message: 'Çıkarılacak soru listesinde tekrar eden kayıt var.',
        path: ['remove_question_ids'],
      })
    }

    if (value.add_question_ids.some((id) => removeIds.has(id))) {
      context.addIssue({
        code: 'custom',
        message: 'Aynı soru tek istekte hem eklenip hem çıkarılamaz.',
      })
    }
  })

export type TCreateQuestionPoolFormSchema = z.infer<
  typeof createQuestionPoolSchema
>
export type TEditQuestionPoolFormSchema = z.infer<typeof editQuestionPoolSchema>
